<template>
    <div class="w_customer_article">
        <Bread :list="['咨询案例','CMF案例库']"></Bread>
        <div class="detailBanner"></div>
        <div class="minWidth caseMain">
            <div class="cmfLibrarydetail clearfix" v-if="dto.id>0">
            <div class="right_item_content">
                <div class="desc_item">
                    <div class="tibar">案例部件</div>
                    <div class="item">
                        <div class="caseLabel">
                            <ul>
                                <li class="clearfix">
                                    <span class="name">行业</span>
                                    <div class="label">
                                        {{dto.anli_hangye?dto.anli_hangye:'--'}}
                                    </div>
                                </li>
                                <li class="clearfix">
                                    <span class="name">设计师</span>
                                    <div class="label">
                                        {{dto.designer?dto.designer:'--'}}
                                    </div>
                                </li>
                                <li class="clearfix">
                                    <span class="name">品牌</span>
                                    <div class="label">
                                        {{dto.brand?dto.brand:'--'}}
                                    </div>
                                </li>
                                <li class="clearfix">
                                    <span class="name">设计公司</span>
                                    <div class="label">
                                        {{dto.designer_company?dto.designer_company:'--'}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="partShow">
                            <ul>
                                <template v-for="(item) in dto.parts">
                                    <li v-if="dto.parts" :key="'part_'+item.id">
                                        <div class="title">{{item.title}}</div>
                                        <div class="info">
                                            <p>材料：<b>{{item.material}}</b></p>
                                            <p>工艺：<b>{{item.craft}}</b></p>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <div class="left_item_content">
                <div class="picbundle">
                    <div class="topBar clearfix">
                        <div class="topName">
                            {{dto.title}}
                        </div>
                    </div>
                    <div class="slideswiper" v-if="dto.albums">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-zoom-container" v-for="(image, index) in dto.albums.split(',')" :key="index">
                                    <img :src="utils.HandleImg(image,false,1)" />
                                </div>
                            </div>
                            <!-- Add Pagination -->
                            <div class="swiper-pagination"></div>
                            <!-- Navigation -->
                            <div class="swiper-button-next"></div>
                            <div class="swiper-button-prev"></div>
                        </div>
                    </div>
                </div>
                <div class="detail_desc">
                    <div class="tibar">
                        <h2>案例描述</h2>
                    </div>
                    <div class="descCon" v-html="utils.HandleContentImg(dto.content)">
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import Bread from '../../components/Common/Bread.vue'
export default {
    data(){
        return{
            id:this.$route.params.id,
            dto:{},
            title:'详情'
        }
    },
    props:{
        paramid:{
        }
    },
    components:{
        Bread
    },
    created(){
    },
    mounted:function(){
        this.GetDetail();
    },
    methods:{
        GetDetail(){
            var url="http://api.xincailiao.com/Open/GetAnliDetail";
            this.$http.post(url,{id:this.id}).then(function(res){
                if (res.data.status==1){
                    this.dto=res.data.ds;
                    this.title=res.data.ds.title;
                    this.InitAlbums();
                }
            }.bind(this)).catch(function(){
            });
        },
        InitAlbums(){
            this.$nextTick(function(){
                new Swiper('.swiper-container', {
                    zoom:true,
                    slidesPerView: 1,
                    centeredSlides: true,
                    loop: true,
                    autoplay: true,
                    pagination: {
                        el: '.swiper-pagination',
                        // clickable: true,
                        // type: 'fraction',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            });
        }
    }
}
</script>